import {Stack} from "@mui/material";

export interface Props {
    small?: boolean;
}

export const RainDrop: React.FC<Props> = ({small}) => {
    const style = {
        width: small === true ? "24px" : "3.75rem",
        height: small === true ? "24px" : "3.75rem",
        minWidth: small === true ? "24px" : "3.75rem",
    };
    const svgWidth = small === true ? 10 : 30;
    const svgHeight = small === true ? 12 : 34;
    return (
        <Stack
            direction="column"
            sx={{
                backgroundColor: "#B7C2EB",
                borderRadius: "0.25rem",
                alignItems: "center",
                justifyContent: "center",
                ...style,
            }}
        >
            <svg width={svgWidth} height={svgHeight} viewBox="0 0 30 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.9922 2L23.8359 10.7894C25.5849 12.5265 26.7762 14.7401 27.2592 17.1502C27.7422 19.5603 27.4951 22.0586 26.5493 24.3291C25.6034 26.5996 24.0013 28.5403 21.9455 29.9058C19.8897 31.2712 17.4726 32 15 32C12.5274 32 10.1103 31.2712 8.05452 29.9058C5.99873 28.5403 4.39658 26.5996 3.45073 24.3291C2.50487 22.0586 2.25781 19.5603 2.74079 17.1502C3.22377 14.7401 4.41509 12.5265 6.16407 10.7894L14.9922 2Z"
                    stroke="white"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </Stack>
    );
};
